import { Text, TextProps } from "@chakra-ui/react";

export function Text10({ children, ...rest }: TextProps) {
  return (
    <Text fontSize="xs" fontWeight="400" lineHeight="12.2px" {...rest}>
      {children}
    </Text>
  );
}

export function Text11({ children, ...rest }: TextProps) {
  return (
    <Text fontSize="11px" fontWeight="400" lineHeight="13.2px" {...rest}>
      {children}
    </Text>
  );
}

export function Text12({ children, ...rest }: TextProps) {
  return (
    <Text fontSize="sm" fontWeight="400" lineHeight="14.4px" {...rest}>
      {children}
    </Text>
  );
}

export function Text14({ children, ...rest }: TextProps) {
  return (
    <Text fontSize="md" fontWeight="400" lineHeight="16.8px" {...rest}>
      {children}
    </Text>
  );
}

export function Text16({ children, ...rest }: TextProps) {
  return (
    <Text fontSize="lg" fontWeight="400" lineHeight="19.2px" {...rest}>
      {children}
    </Text>
  );
}

export function Text18({ children, ...rest }: TextProps) {
  return (
    <Text fontSize="18px" fontWeight="400" lineHeight="21.6px" {...rest}>
      {children}
    </Text>
  );
}
